/* Daellia V3 ("Bleu Daellia"): lazy video loops and small interactions. No dependencies.
   The theme scrolls inside div.page-wrapper; IntersectionObserver with the default (viewport) root
   still reports intersections for elements inside that nested scroller. */
(function () {
  'use strict';

  var doc = document.documentElement;
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var reduceMotion = !!(mq && mq.matches);
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var hasIO = 'IntersectionObserver' in window;

  /* ---------- Video loops ---------- */
  function play(video) {
    if (!video.dataset.dlLoaded) return;
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function load(video) {
    if (video.dataset.dlLoaded) return;
    var src = video.getAttribute('data-src');
    if (!src) return;
    video.dataset.dlLoaded = '1';
    video.src = src;
    video.addEventListener('loadeddata', function () { video.classList.add('is-playing'); }, { once: true });
    try { video.load(); } catch (e) {}
  }

  var loadObserver = null;
  var playObserver = null;

  function initVideos(root) {
    var videos = (root || document).querySelectorAll('video[data-dl-video]');
    if (!videos.length) return;

    if (reduceMotion || saveData) {
      videos.forEach(function (v) {
        v.removeAttribute('autoplay');
        v.classList.add('is-static');
      });
      return;
    }

    if (!hasIO) {
      videos.forEach(function (v) { load(v); play(v); });
      return;
    }

    if (!loadObserver) {
      loadObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            load(entry.target);
            loadObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '300px 0px 300px 0px', threshold: 0 });

      playObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            load(v);
            play(v);
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: 0.01 });
    }

    videos.forEach(function (v) {
      if (v.dataset.dlObserved) return;
      v.dataset.dlObserved = '1';
      loadObserver.observe(v);
      playObserver.observe(v);
    });
  }

  /* Pause everything when the tab is hidden. */
  document.addEventListener('visibilitychange', function () {
    var videos = document.querySelectorAll('video[data-dl-video]');
    videos.forEach(function (v) {
      if (document.hidden) {
        if (!v.paused) v.pause();
      } else if (v.dataset.dlLoaded) {
        var r = v.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight) play(v);
      }
    });
  });

  /* ---------- Newsletter: star loading state ---------- */
  function initForms(root) {
    (root || document).querySelectorAll('.dl-news3 form').forEach(function (form) {
      if (form.dataset.dlBound) return;
      form.dataset.dlBound = '1';
      form.addEventListener('submit', function () {
        var btn = form.querySelector('button[type="submit"]');
        if (btn) {
          btn.classList.add('is-loading');
          btn.setAttribute('aria-busy', 'true');
        }
      });
    });
  }

  /* ---------- Reduced motion changes at runtime ---------- */
  if (mq && typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', function (e) {
      reduceMotion = e.matches;
      if (reduceMotion) {
        document.querySelectorAll('video[data-dl-video]').forEach(function (v) { v.pause(); });
      }
    });
  }

  function init() {
    initVideos();
    initForms();
    doc.classList.add('dl-v3');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initVideos(event.target);
    initForms(event.target);
  });
})();
